import { format, parseISO } from 'date-fns';
import { DarwinFlex } from '../../Flex';
import Icon from '../../Icon';
import { CombinedText } from 'components/darwin-ui/ListView/HighlightedText';
import styles from './index.module.css';

const DARWIN_USER = 'Darwin Evolution';

/**
 * Renders a cell for a user.
 * @param user - The user name.
 * @param searchQuery - Query string for highlighting.
 */
export const renderUserCell = (user: string, searchQuery: string) => (
  <DarwinFlex
    justify="center"
    align="center"
    className={`${styles.noWrap} ${styles.userFlex}`}
  >
    <Icon
      name={user ? 'user-outline' : 'darwin-user'}
      className={user ? styles.userOutlineIcon : styles.darwinIcon}
    />
    <CombinedText
      lines={1}
      text={user || DARWIN_USER}
      highlight={searchQuery}
    />
  </DarwinFlex>
);

/**
 * Renders a cell for a name.
 * @param name - The text to display.
 * @param isDarwin - Flag for showing a Darwin icon.
 * @param searchQuery - Query string for highlighting.
 */
export const renderNameCell = (
  name: string,
  isDarwin: boolean,
  searchQuery: string
) => (
  <DarwinFlex
    justify="left"
    align="center"
    className={`${styles.noWrap} ${styles.nameFlex}`}
  >
    {isDarwin ? (
      <Icon name="darwin-user" className={styles.darwinIcon} />
    ) : (
      <div
        className={styles.nameFlexDivPlaceholder}
        data-testid="name-flex-placeholder"
      />
    )}
    <CombinedText lines={1} text={name} highlight={searchQuery} />
  </DarwinFlex>
);

/**
 * Renders a formatted date cell using a default format.
 * @param date - Date string (ISO format).
 */
export const renderDateCell = (date: string) =>
  formatDate(date, 'dd/MM/yyyy - HH:mm');

/**
 * Format a date string in ISO format to a displayable format.
 * @param date - Date string in ISO format.
 * @param formatStr - date-fns format string.
 * @returns Formatted date string or empty string if `date` falsy or invalid.
 */
export const formatDate = (
  date: string,
  formatStr: string = 'dd/MM/yyyy'
): string => {
  if (!date) return '';

  try {
    const parsed = parseISO(date);
    return format(parsed, formatStr);
  } catch {
    return '';
  }
};

export const ACTIONS_COL_WIDTH = 50;
export const STATUS_COL_WIDTH = 120;
